module.exports = __webpack_public_path__ + "static/img/11.e3cfd32.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/XVC/images/11.png
// module id = tTQB
// module chunks = 4